import { combineReducers } from 'redux';
import SessionReducer from "./SessionReducer";
import LibraryReducer from "./LibraryReducer";
import TeamReducer from "./TeamReducer";
import BookingTimeSlotReducer from "./BookingTimeSlotReducer";
import BookedReducer from "./BookedReducer";
import UserReducer from "./UserReducer";
import ProgramReducer from "./ProgramReducer";
import ClassReducer from "./ClassReducer";
const allReducers = combineReducers({
     SessionReducer, 
     LibraryReducer,
     TeamReducer,
     BookingTimeSlotReducer,
     BookedReducer,
     UserReducer,
     ProgramReducer,
     ClassReducer
});

export default allReducers;

